export default __webpack_public_path__ + "static/media/tasks.b7cf253a.svg";